<template>
    <div  class="position-relative" :class="{'has-overlay': loading}">
        <div class="d-flex flex-row">
            <div class="h3 flex-grow-1 d-flex align-items-center flex-wrap" >
                <div class="mr-2 mb-1">{{ getHeader(object.id) }}</div>
                <small  class="mb-1"><raid-status-cell v-if="object.id" :value="object.statusObject" /></small>
            </div>

            <div class="d-flex">
                <div class="flex-grow-0">
                    <b-button variant="outline-secondary" size="lg" class="border-0 p-0"  @click="onCancel">
                        <b-icon icon="x" />
                    </b-button>
                </div>
            </div>
        </div>

        <small class="text-secondary d-flex flex-column mb-3">
            <span>{{ request.objectLabel() }}</span>
            <span>{{ request.description }}</span>
        </small>

            <b-form-row class="mt-2 mb-2 pt-3 border-top" >
                <date-time-picker class="col-12"
                                  title="Запланирован"
                                  name="plannedAt"
                                  :key="object.plannedAt"
                                  :editable="getAbility('plannedAt') && !object.id  && !isCompleted"
                                  :show-timepicker="true"
                                  :initial-date-string="getInitialDateString()"
                                  :state="validateState('plannedAt')"
                                  @date-changed="onModelDateChanged" />
            </b-form-row>

            <b-form-row class="mt-4 mb-2" v-if="object.id && isCompleted && object.status === 2">
                <date-time-picker class="col-12"
                                  title="Проведен"
                                  name="actualDate"
                                  :editable="false"
                                  :show-timepicker="true"
                                  :date-required="false"
                                  :initial-date-string="object.actualDate"
                                  :state="validateState('actualDate')"
                                  @date-changed="onModelDateChanged" />
            </b-form-row>

            <b-form-row class="mt-2 mb-2">
                    <form-field
                            :label="getFieldLabel('address')"
                            class="col-12"
                            :class="{ 'required': getAbility('address') && !isCompleted && !object.id }"
                            :editable="getAbility('address') && !isCompleted && !object.id"
                            :feedback="liveFeedback('address')"
                            :value="form.addressHumanReadable ? form.addressHumanReadable : 'Не указан'">

                            <template #value>
                                <map-box ref="map" :coordinates="selectedCoordinates" style="width: 100%; height: 500px"/>
                                <div class="clearfix p-1"></div>
                                <div class="col-12 p-0 m-0 d-flex align-items-center">
                                    <div class="flex-grow-1 mr-2">{{ form.addressHumanReadable ? form.addressHumanReadable : 'Не указан' }}</div>
                                    <b-button variant="link" class="p-0" @click="onAddressFocus">
                                        <img :src="focus" width="32"/>
                                    </b-button>
                                </div>
                            </template>

                        <template #field>
                            <map-box ref="map" :coordinates="selectedCoordinates" v-on:map-clicked="onMapClicked" style="width: 100%; height: 500px"/>
                            <div class="clearfix p-1"></div>
                            <div class="col-12 p-0 m-0 d-flex">
                                <single-select name="address"
                                               ref="address"
                                               class="flex-grow-1 mr-2"
                                               v-model="form['addressObject']"
                                               :url="getAddressUrl"
                                               :label="getFieldLabel('address')"
                                               label-key="human_readable_address"
                                               :state="getValidationClass('address')"
                                               :has-pagination="false"
                                               v-on:select-search-init="onAddressSearchStart"
                                               v-on:select-changed="onAddressChanged"
                                               v-on:select-set="onAddressSet"
                                               v-on:select-cleared="onModelObjectSingleSelectCleared" />
                                <b-button variant="link" class="p-0" @click="onAddressFocus">
                                    <img :src="focus" width="32"/>
                                </b-button>
                            </div>
                        </template>
                    </form-field>
            </b-form-row>

            <b-form-row v-if="object.id" class="mb-2">
                <form-field :label="getFieldLabel('comment')"
                            :value="object.comment"
                            :editable="getAbility('comment')"
                            :feedback="liveFeedback('comment')"
                            class="col-12 mt-2 mb-2">
                        <template #field>
                            <b-form-textarea
                                id="comment"
                                class="w-100 mb-2"
                                 v-model="$v.form.comment.$model"
                                :state="validateState('comment')">
                            </b-form-textarea>
                        </template>
                </form-field>
            </b-form-row>

            <b-form-row class="mb-2" v-if="object.status === 1 || object.status === 2">
                <div class="d-flex col-12 align-items-end">
                    <form-field :label="getFieldLabel('animalsToRelease')"
                                class="flex-grow-1 mr-3"
                                :editable="getAbility('animalsToRelease')"
                                :feedback="liveFeedback('animalsToRelease')"
                                :value="object.animalsToRelease">
                        <template #field>
                            <list-select name="animalsToRelease"
                                         v-model="form['animalObjectsToRelease']"
                                         :url="getAnimalsUrl"
                                         :label="getFieldLabel('animalsToRelease')"
                                         :state="getValidationClass('animalsToRelease')"
                                         :initial-filters="animalsToReleaseInitialFilters"
                                         label-key="full_name"
                                         v-on:select-added="onAnimalToReleaseAdded"
                                         v-on:select-removed="onAnimalToReleaseRemoved">
                                <template v-slot:selected-item="slotProps">
                                    <animal-dropdown-item :animal="slotProps.item" class="text-secondary"/>
                                </template>
                                <template v-slot:option="slotProps">
                                    <animal-dropdown-item :animal="slotProps.item" />
                                </template>
                            </list-select>
                        </template>
                    </form-field>

                    <div class="d-flex flex-grow-0 p-0">
                        <div class="flex-grow-1 d-flex flex-column">
                            <b-button @click="onUpdateRaid" :disabled="loading" v-if="object.id && $v.form.$anyDirty" variant="primary">Сохранить</b-button>
                            <b-button @click="onCreate" :disabled="loading" v-if="!object.id" variant="primary" class="p-2">Создать</b-button>
                            <b-button @click="onCancelRaid" :disabled="loading" v-if="object.id && !$v.form.$anyDirty && canEditRaid && object.status === 1" variant="danger">Отменить рейд</b-button>
                            <b-button @click="onConfirm" :disabled="loading" v-if="object.id && form['animalObjectsToRelease'].length && !$v.form.$anyDirty && canEditRaid" variant="success" class="mt-2">Подтвердить выпуск</b-button>
                        </div>
                    </div>
                </div>
            </b-form-row>

            <b-form-row class="mb-2" v-if="object.status === 2 && form['alreadyReleasedAnimals'].length">
                <div class="clearfix p-2"></div>
                <div class="d-flex col-12 align-items-end">
                    <div class="d-flex flex-column flex-grow-1">
                        <span class="mb-2">Ранее выпущенные в рейде животные</span>
                        <div class="flex-grow-1 d-flex flex-wrap">
                            <div v-for="(animal, i) in form['alreadyReleasedAnimals']" class="mb-3 mr-3">
                                <animal-link :animal="animal" />
                            </div>
                        </div>
                    </div>
                </div>
            </b-form-row>

            <b-form-row class="mb-2" v-if="object.status !== 2 && object.status !== 1">
                <div class="d-flex col-12 justify-content-end">
                    <div class="flex-grow-0">
                        <b-button @click="onUpdateRaid" v-if="object.id && $v.form.$anyDirty" variant="primary">Сохранить</b-button>
                    </div>
                </div>
            </b-form-row>

        <div class="overlay">
            <div class="d-flex w-100 h-100 align-items-center justify-content-center">
                <b-spinner variant="light" />
            </div>
        </div>


    </div>
</template>

<script>
import {ObjectComponentMixin} from "@/components/Forms/ObjectComponentMixin";
import {Raid, RaidStatus} from "@/pages/AppPages/Raids/raid";
import RaidStatusCell from "@/pages/DataTableCells/RaidStatusCell";
import DateTimePicker from "@/components/Forms/DateTimePicker";
import FormField from "@/components/Forms/FormField";
import SingleSelect from "@/components/Select/SingleSelect";
import api from "@/api";
import ListSelect from "@/components/Select/ListSelect";
import DataTable from "@/components/Table/DataTable";
import AnimalAvatar from "@/pages/AppPages/Animals/AnimalAvatar";
import {mapGetters} from "vuex";
import {ACTIVITIES} from "@/store/auth/auth";
import {ModalMixin} from "@/components/Forms/ModalMixin";
import {MapMixin} from "@/components/Map/mapMixin";
import MapBox from "@/components/Map/MapBox.vue";
import AnimalLink from "@/pages/AppPages/Animals/AnimalLink.vue";
import AnimalDropdownItem from "@/pages/AppPages/Animals/AnimalDropdownItem.vue";

export default {
    name: "ReleaseRaidModalDetail",
    components: {
        AnimalDropdownItem,
        AnimalLink,
        MapBox, AnimalAvatar, DataTable, ListSelect, SingleSelect, FormField, DateTimePicker, RaidStatusCell},
    mixins: [ ObjectComponentMixin, ModalMixin, MapMixin ],
    props: {
        raidId: { type: null, default: null },
        request: { type: Object, default: () => { return {} }},
        animalFilters: { type: Array, default: () => { return [] } }
    },
    data() {
        return {
            excludeAnimalsRevert: []  // PETS-397: т.к. исключение животных из запроса с помощью фильтра exclude идет с формы заявки через prop,
            // то при удалении выбранного животного из списка запланированного рейда не происходит обновления самой заявки.
            // Будем явно указывать животных, которых исключают из списка при редакитировании рейда
        }
    },
    computed: {
        ...mapGetters(['ability', 'userOrganizationActivities', 'isSuperuser']),
        isCompleted() {
            return this.object.isCompleted;
        },
        animalsToReleaseInitialFilters() {
            let filters = [{key: 'release_request', value: this.request.id}];
            if (this.object && this.object.id) {
                filters.push({key: 'release_raid', value: this.object.id})
            }
            filters = [...filters]
            for (const filter of this.animalFilters) {
                if (this.excludeAnimalsRevert.indexOf(filter.value) < 0) {
                    filters.push(filter)
                }
            }
            return filters
        },
        getAnimalsUrl() {
            return api.animals.default.list();
        },
        createUrl() {
            return api.raids.default.list();
        },
        updateUrl() {
            return api.raids.default.detail(this.objectId);
        },
        canPerformRelease() {
            return this.isSuperuser || this.userOrganizationActivities.includes(ACTIVITIES.RELEASE)
        },
        canCreateRaid() {
            return this.ability.can('create', 'Raid') && this.canPerformRelease
        },
        canEditRaid() {
            return this.ability.can('update', this.object) && this.canPerformRelease
        }
    },
    methods: {
        // getAnimalLowercaseGender(animal) {
        //     return animal['gender_name'] ? animal['gender_name'].toLowerCase() : 'пол не указан'
        // },
        getInitialDateString() {
            return this.object.plannedAt;
        },
        onCancelRaid() {
            const vm = this;
            this.form['status'] = RaidStatus.FAIL
            this.onUpdate();
            vm.setMapCoordinates(vm.object.coordinates)
        },
        onUpdateRaid() {
            const vm = this;
            this.onUpdate();
            vm.setMapCoordinates(vm.object.coordinates)
        },
        onConfirm() {
            let animalObjectsToReleaseIds = [];
            for (const animalObject of this.form['animalObjectsToRelease']) {
                animalObjectsToReleaseIds.push(animalObject.id)
            }
            this.$router.replace({ name: 'raidReleaseCreate', params: { raidId: this.raidId }, query: { animal: animalObjectsToReleaseIds } })
        },
        onAnimalToReleaseAdded(name, item) {
            const vm = this;
            vm.onModelObjectListAdded(name, item);
            for (let i = 0; i < vm.excludeAnimalsRevert.length; i++) {
                const animalId = vm.excludeAnimalsRevert[i]
                if (item.value === animalId) {
                    vm.excludeAnimalsRevert.splice(i, 1);
                    break
                }
            }
        },
        onAnimalToReleaseRemoved(name, item) {
            const vm = this;
            vm.onModelObjectListRemoved(name, item);
            vm.excludeAnimalsRevert.push(item.id)
        }
    },
    beforeMount() {
        this.objectClass = Raid;
        this.objectId = this.raidId;
        this.initObjectParams = {
            request: this.request.id,
            address: this.request.address,
            addressObject: this.request.addressObject,
            lat: this.request.lat,
            lon: this.request.lon,
            requestContractorId: this.request.assignedToId,
            plannedCount: this.request.animalsLeft
        };
    },
    mounted() {
        const vm = this;
        vm.onMount();
        vm.resetForm().then(() => {
            if (vm.object.addressObject['id']) {
                vm.setMapCoordinates(vm.object.coordinates)
            }
        });
    },
}
</script>

<style scoped lang="scss">
.btn-link {
    text-decoration: none;
    &:hover {
        text-decoration: none !important;
    }
}

</style>